import { jsxs, jsx } from "react/jsx-runtime";
import Skeleton from "../../../../../../feedback/Skeleton/Skeleton.js";
import Group from "../../../../../../layout/Group/Group.js";
const NavbarSkeletons = () => /* @__PURE__ */ jsxs(Group, { spacing: "xl", children: [
  /* @__PURE__ */ jsx(Skeleton, { height: 24, width: 100 }),
  /* @__PURE__ */ jsx(Skeleton, { height: 24, width: 100 }),
  /* @__PURE__ */ jsx(Skeleton, { height: 24, width: 100 }),
  /* @__PURE__ */ jsx(Skeleton, { height: 24, width: 100 })
] });
export {
  NavbarSkeletons as default
};
